import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';

/**
 * Dvere (Doors) - Fold-open door cards with images
 *
 * Layout: 5 portrait pages, 2 cards per page.
 * Each card: image centered on left door and right door panels, fold lines for opening.
 *
 * Migrated from C# EduFrame.Img10.Generators.Dvere
 */
export class Dvere implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 2;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 50;
  }
  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const sizeW = PdfSize.A4.width - 2 * margin;
    const sizeH = PdfSize.A4.height / 2 - margin;
    const size2W = sizeW / 2;
    const size2H = size2W;
    const size4W = sizeW / 4;

    for (let i = 0; i < opts.list.length; i++) {
      const pageIdx = Math.floor(i / 2);
      while (pdf.gs.length <= pageIdx) pdf.addPage();
      const page = pdf.getPage(pageIdx);

      const rect = new PdfRect(margin, margin + (i % 2) * sizeH, sizeW, sizeH);

      const r1 = new PdfRect(
        margin - size2W / 2,
        rect.top + (rect.height - size2H) / 2,
        size2W,
        size2H
      );
      const r2 = new PdfRect(margin + 3 * size4W, r1.top, size2W, size2H);

      page.drawImageCenter(opts.list[i].image, r1);
      page.drawImageCenter(opts.list[i].image, r2);

      page.drawRectangle(GUtil.cutPen, null, rect);
      page.drawLine(
        GUtil.foldPen,
        new PdfPoint(rect.left + size4W, rect.top),
        new PdfPoint(rect.left + size4W, rect.bottom)
      );
      page.drawLine(
        GUtil.foldPen,
        new PdfPoint(rect.left + 3 * size4W, rect.top),
        new PdfPoint(rect.left + 3 * size4W, rect.bottom)
      );
    }
  }
}
